const routes = {
  AUTH_VIEW: '/auth',
  AUTH_SIGNUP: '/auth/signup',
  AUTH_SIGNIN: '/auth/signin',
  MAIN_VIEW: '/',
  TEST_VIEW: '/test',
  RESULT_VIEW: '/result',
  USEFUL_INFO_VIEW: '/useful-info',
  CONTACTS_VIEW: '/contacts',
  GOOGLE_AUTH_VIEW: '/auth/google/',

  WRONG: '/wrong',

  GOOGLE_AUTH_URL: 'https://intense-stream-90411.herokuapp.com/auth/google',

};

export default routes;
